import { formatDate } from '@/utils/normalize'
import { formatDistanceToNowStrict, isSameDay, subDays } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000

function parse(value: string): Date | null {
  const date = new Date(value)

  return Number.isNaN(date.getTime()) ? null : date
}

/**
 * Idade da notificação em texto curto ("há 5 minutos"). Passada uma semana o tempo relativo deixa
 * de ajudar ("há 2 meses" não localiza nada), então volta a data cheia.
 */
export function formatNotificationAge(value: string): string {
  const date = parse(value)

  if (!date) {
    return ''
  }

  const elapsed = Date.now() - date.getTime()

  if (elapsed < 60 * 1000) {
    return 'agora'
  }

  if (elapsed < WEEK_IN_MS) {
    return formatDistanceToNowStrict(date, { addSuffix: true, locale: ptBR })
  }

  return formatDate(value, true)
}

/** Data por extenso do separador do modal: "Hoje", "Ontem" ou "12 de setembro de 2026". */
export function formatNotificationDay(value: string): string {
  const date = parse(value)

  if (!date) {
    return 'Sem data'
  }

  const now = new Date()

  if (isSameDay(date, now)) {
    return 'Hoje'
  }

  if (isSameDay(date, subDays(now, 1))) {
    return 'Ontem'
  }

  return new Intl.DateTimeFormat('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(date)
}

/** Data e hora completas, no formato que o resto do sistema usa. */
export function formatNotificationDate(value: string): string {
  return formatDate(value, true)
}
